import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';

// Endpoints that answer their own 404 in place, and so are exempt from the
// bounce to the generic platform not-found page. The share claim screen is
// one: diplomat answers an unknown or already-spent token with 404, and the
// screen says so where the claimant is, rather than losing them to
// /errors/not-found. Everything else still bounces.
const selfHandledNotFound: string[] = ['acceptShare'];

export const errors: Middleware =
  (api: MiddlewareAPI) => (next) => (actiont) => {
    const action = actiont as any;
    if (isRejectedWithValue(action)) {
      // Handle 403s, by bouncing back to login screen
      if (action?.payload?.status === 403) {
        const state = api.getState();
        if (
          (state?.api?.queries ?? {})['session(undefined)']?.status !==
          'pending'
        ) {
          localStorage.removeItem('kinesis:session');
          if (
            window.location.pathname !== '/' &&
            !window.location.pathname.startsWith('/login')
          ) {
            localStorage.setItem(
              'kinesis:redirect',
              `${window.location.pathname}${window.location.search}`,
            );

            window.location.assign('/');
          }
        }
      } else if (action?.payload?.status === 500) {
        if (import.meta.env.PROD) {
          (window as any).Rollbar.error('Server error', action);
        }
        window.location.assign(
          `/errors/server?errorId=${action?.payload?.data?.errorId}`,
        );
      } else if (action?.payload?.status === 404) {
        if (!selfHandledNotFound.includes(action?.meta?.arg?.endpointName)) {
          if (import.meta.env.PROD) {
            (window as any).Rollbar.error('Not found error', action);
          }
          window.location.assign(`/errors/not-found`);
        }
      }
      // Note: we don't handle 400s, they should be handle by the
      // component/mutation where they can happen.
    }
    return next(action);
  };
